import { atom } from "jotai";

export const entrevistasAtom = atom([]);
export const entrevistaSeleccionadaAtom = atom(undefined);
export const competenciasAtom = atom([]);
export const preguntasAtom = atom([]);
export const loadingAtom = atom(false)